// Stop the type system complaining about redux devtools,
// which is attached to the Window by chrome/ff extension "redux-devtools".
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: any;
    Cypress: any;
    store: any;
  }
}

export interface NavLinkProps {
  to: string;
  children: React.ReactNode;
}

export enum HTTPMethod {
  GET = "GET",
  PUT = "PUT",
  PATCH = "PATCH",
  POST = "POST",
  HEAD = "HEAD",
  DELETE = "DELETE",
}

export interface ApexApiError extends Error {
  response?: Response;
  status?: number;
}

export interface menuItem {
  headerText: string;
  parentHeader: string;
  urlText: string;
  webLinkId: string;
}

export enum HTTPStatusCodes {
  STATUS_OK = 200,
  STATUS_REDIRECT = 302,
  STATUS_SEE_OTHER = 303,
  STATUS_BAD_REQUEST = 400,
  STATUS_UNAUTHORIZED = 401,
  STATUS_NOT_FOUND = 404,
  STATUS_PRECONDITION_FAILED = 412,
  STATUS_INTERNAL_SERVER_ERROR = 500,
}
